import React from 'react';
import {
  GridRowCardByRowContainer,
  GridRowCardByRowItem,
  GridRowCardByRowStrong,
  GridRowCardByRowLabel,
  GridRowCardByRowValue,
  GridRowCardByRowButton
} from './styles'
import { BsPlus } from 'react-icons/bs';
import { formatIdentification } from '../../helpers/string';
import { useHistory } from 'react-router-dom';
import colors from '../../assets/styles/colors';

const GridRowCardClient = ({ item }) => {
  const history = useHistory();

  return (
    <GridRowCardByRowContainer id="card">
      <GridRowCardByRowItem>
        <GridRowCardByRowStrong>{item.nombres}</GridRowCardByRowStrong>
        <GridRowCardByRowValue>{item.tipoIdentificacion}. {formatIdentification(item.identificacion)}</GridRowCardByRowValue>
      </GridRowCardByRowItem>
      <GridRowCardByRowItem>
        <GridRowCardByRowLabel>&nbsp;</GridRowCardByRowLabel>
        <GridRowCardByRowButton id="select-item" onClick={() => history.push({
                                                                    pathname: '/admin/client-modify',
                                                                    client: item
                                                                  })}>
          <BsPlus color={colors.textPrimary} id="plus-icon" />
        </GridRowCardByRowButton>
      </GridRowCardByRowItem>
    </GridRowCardByRowContainer>
  )
}

export default GridRowCardClient;
